// Lib
import { first, last, split } from 'lodash/fp';

// Utils
import randomString from '../../../../common/uid/randomString';

const splitSlash = split('/');
const splitQuery = split('?');

export const getFilenameFromUrl = (url: string, fileType: string): string => {
    const lastPart = (last(splitSlash(url)) as string) ?? '';
    const filename = (first(splitQuery(lastPart)) as string) ?? '';

    if (filename.indexOf('.') > -1) return filename;

    const extension = (last(splitSlash(fileType)) as string) ?? '';
    return `${filename}.${extension}`;
};

export const appendToFilename = (filename: string) => {
    const [base = '', ...rest] = filename.split('.');

    return [`${base}-${randomString(6)}`, ...rest].join('.');
};
